import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "wheel"];

// Logs the user out after `minutes` of no mouse/keyboard/touch activity
// anywhere in the app. Any tracked event resets the timer; it never fires
// while the tab is actively being used, no matter how long the session runs.
export function useIdleLogout(minutes, onIdle) {
  const timerRef = useRef(null);

  useEffect(() => {
    const limitMs = minutes * 60 * 1000;

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(onIdle, limitMs);
    };

    reset();
    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, reset, { passive: true }));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minutes]);
}
